module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am95-cbb0998853fe6cec214b9fa8b9c9e269.jpg";